<template>
  <div class="mainPage">
    <!--报表系统  -->
    <div class="typeArea">
      <div class="firstWrap">
        <div v-for="(item,i) of tabList" :key="i" :class="i==tabIndex?'activeFirst':''" @click="changOneTab(i)">
          {{ item.name }}
        </div>
      </div>
      <!-- 现货订单报表 -->
      <div class="secondWrap" v-if="tabIndex==0">
        <div v-for="twoTab of twoTabList" :key="twoTab.id" :class="twoTabIndex==twoTab.id?'activeSecond':''" @click="openReport(twoTab.id)">
          {{ twoTab.name }}
        </div>
      </div>
      <div class="secondWrap" v-if="tabIndex==1">
        <div v-for="threeTab in treeTabList" :key="threeTab.marketId" :class="treeTabIndex==threeTab.marketId?'activeSecond':''" @click="openThreeReport(threeTab)">
          {{ threeTab.accountName }}流水
        </div>
      </div>
      <div class="chooseWrap">
        <div class="itemSearch">
          <div class="searchTitle">日期</div>
          <div class="searchContent">
            <el-date-picker
              v-model="search.time"
              popper-class="whiteDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
              :default-time="['00:00:00', '23:59:59']"
              :clearable="false"
              :disabled="tabIndex==0&&(twoTabIndex==2||twoTabIndex==3)"
              :picker-options="pickerOptions"
              @blur="judgeTime"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="itemSearch">
          <div class="searchContent">
            <el-radio-group v-model="search.radio" @change="changeRadio">
              <el-radio v-for="(rodioItem,index) of radioList" :key="index" :disabled="tabIndex==0&&(twoTabIndex==2||twoTabIndex==3)" :label="rodioItem.label">{{ rodioItem.name }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="actionSearch">
          <el-button
            class="searchBtn"
            plain
            size="small"
            :disabled="tabIndex==0&&(twoTabIndex==2||twoTabIndex==3)"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="restBtn"
            :disabled="tabIndex==0&&(twoTabIndex==2||twoTabIndex==3)"
            size="small"
            @click="restData"
          >重置</el-button>
        </div>
      </div>
      <div class="tableWrap" v-if="tabIndex==0">
        <!-- 表单内容 -->
        <orderTabFirst v-if="twoTabIndex==0" ref="aa" :time="search.time" :is-search="isSearch" />
        <orderTabTwo v-if="twoTabIndex==1" ref="bb" :time="search.time" :is-search="isSearch" />
        <orderTabThree v-if="twoTabIndex==2" ref="cc" />
        <orderTabFour v-if="twoTabIndex==3" ref="dd" />
        <!-- <orderTabFive v-if="twoTabIndex==5" ref="ee" :time="search.time" :is-search="isSearch" /> -->
        <orderTabSix v-if="twoTabIndex==4" ref="ff" :time="search.time" :is-search="isSearch" />
        <TradeDueToDelivery v-if="twoTabIndex==6" ref="gg" :time="search.time" :is-search="isSearch" />
        <MyDeliveryTheQuery v-if="twoTabIndex==7" ref="hh" />
        <DeilveryHis v-if="twoTabIndex==8" ref="kk" :time="search.time" :is-search="isSearch" />
      </div>
      <div class="tableWrap" v-if="tabIndex==1">
        <!-- 表单内容 -->
        <threeAsset ref="zjf" :market-id="treeTabIndex" :time="search.time" :is-search="isSearch" />
      </div>
    </div>
  </div>
</template>
<script>
/*global util */
import orderTabFirst from './orderTab/orderTabFirst'
import orderTabTwo from './orderTab/orderTabTwo'
import orderTabThree from './orderTab/orderTabThree'
import orderTabFour from './orderTab/orderTabFour'
import orderTabSix from './orderTab/orderTabSix'
import threeAsset from './assetTab/threeAsset'
import TradeDueToDelivery from '@views/nonTrade/tab/TradeDueToDelivery'
import exportExcel from '@/assets/baseServe/exportExcel/exportExcel.vue'
import MyDeliveryTheQuery from '@views/nonTrade/tab/MyDeliveryTheQuery'
import DeilveryHis from '@views/nonTrade/tab/DeilveryHis'
export default ({
  components: {
    orderTabFirst,
    orderTabTwo,
    orderTabThree,
    orderTabFour,
    orderTabSix,
    threeAsset,
    TradeDueToDelivery,
    exportExcel,
    MyDeliveryTheQuery,
    DeilveryHis
  },
  data() {
    return {
      pickerOptions: {
        // 禁用不可选的日期
        disabledDate: (time) => {
          // 计算7天前的日期（不含时间部分）
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
          sevenDaysAgo.setHours(0, 0, 0, 0);
          // 计算今天的结束时间（23:59:59）
          const todayEnd = new Date();
          todayEnd.setHours(23, 59, 59, 999);
          // 禁用早于7天前或晚于今天的日期
          return time.getTime() < sevenDaysAgo.getTime() || time.getTime() > todayEnd.getTime();
        }
      },
      isSearch: false,
      tabIndex: 0,
      search: {
        time: null,
        radio: 1
      },
      searchForm: {
        startTradeDay: null,
        endTradeDay: null
      },
      tabList: [
        { name: '订单报表'}, 
        { name: '资金报表' }
      ],
      twoTabIndex: 0,
      twoTabList: [{
        name: '委托明细',
        id: 0
      }, {
        name: '成交明细',
        id: 1
      }, {
        name: '持仓汇总',
        id: 2
      }, {
        name: '持仓明细',
        id: 3
      },
      {
        name: '资金状况',
        id: 4
      },
      {
        name: '交收成交查询',
        id: 8
      }
      ],
      treeTabIndex: 0,
      treeTabList: window.g.APP_market,
      radioList: [{
        label: 0,
        name: '当前'
      }, {
        label: 1,
        name: '上日'
      }, {
        label: 2,
        name: '上周'
      },
      {
        label: 4,
        name: '上月'
      }, {
        label: 5,
        name: '本月'
      }],
      beginTimeT: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))],
      beginZtime: [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)],
      currentDate: new Date(),
      millisecond: 1000 * 60 * 60 * 24 // 一天的毫秒数
    }
  },
  created() {
    this.search.time = this.beginTimeT
    this.search.radio = 0
  },
  mounted() {
    this.searchForm.startTradeDay = null
    this.searchForm.endTradeDay = null
  },
  methods: {
    // 改变一级分类
    changOneTab(i) {
      this.search.radio = 0
      this.search.time = [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
      this.tabIndex = i
    },
    // 改变二级分类
    openReport(index) {
      this.search.radio = 0
      this.search.time = [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
      this.twoTabIndex = index
      this.searchForm = {
        startTradeDay: this.search.radio === 0 ? null : this.search.time[0],
        endTradeDay: this.search.radio === 0 ? null : this.search.time[1],
        sort: [
          {
            direction: 'DESC', // "//DESC或ASC",
            property: 'createTime' // "//排序属性"
          }
        ]
      }
    },
    // 改变三级分类
    openThreeReport(item) {
      this.isLast = false
      this.search.radio = 0
      this.search.time = [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
      this.treeTabIndex = item.marketId
      this.searchForm = {
        starTime: this.search.radio === 0 ? null : this.search.time[0],
        endTime: this.search.radio === 0 ? null : this.search.time[1],
        sort: [
          {
            direction: 'DESC', // "//DESC或ASC",
            property: 'occurTime' // "//排序属性"
          }
        ]
      }
      this.$nextTick(() => [
        this.$refs.zjf.loadData()
      ])
    },
    judgeTime(timeObj) {
      const beforWeek = this.formatTime(this.getLastWeek()) // 上周
      const currentWeek = this.formatTime(this.getThisWeek()) // 本周
      const beforMoth = this.formatTime(this.getLastMonth()) // 上月
      const currentMoth = this.formatTime(this.getThisMonth()) // 本月
      const newTime = timeObj.value
      if (this.beginTimeT[0] == newTime[0] && this.beginTimeT[1] == newTime[1]) {
        this.search.radio = 0
      } else if (this.beginZtime[0] == newTime[0] && this.beginZtime[1] == newTime[1]) {
        this.search.radio = 1
      } else if (beforWeek[0] == newTime[0] && beforWeek[1] == newTime[1]) {
        this.search.radio = 2
      } else if ((currentWeek[0] == newTime[0] && currentWeek[1] == newTime[1])) {
        this.search.radio = 3
      } else if ((beforMoth[0] == newTime[0] && beforMoth[1] == newTime[1])) {
        this.search.radio = 4
      } else if ((currentMoth[0] == newTime[0] && currentMoth[1] == newTime[1])) {
        this.search.radio = 5
      } else {
        this.search.radio = 10 // 选择的日期不存在列表中
      }
    },
    // 判断两个时间是否超过一个月
    calcMoth(timer1, timer2) {
      const time1 = timer1.slice(0, 4) + '-' + timer1.slice(4, 6) + '-' + timer1.slice(6, 8)
      const time2 = timer2.slice(0, 4) + '-' + timer2.slice(4, 6) + '-' + timer2.slice(6, 8)
      const toime1 = new Date(time1).getTime()
      const toime2 = new Date(time2).getTime()
      const mountDay = 31 * 24 * 60 * 60 * 1000
      if (Number(toime1) - Number(toime2) > mountDay) {
        return true
      }
      return false
    },
    searchData() {
      if (this.calcMoth(this.search.time[1], this.search.time[0])) {
        return this.$message('查询时间不能大于1个月')
      }
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    restData() {
      // 重置报表
      this.search.time = this.beginTimeT
      this.search.radio = 0
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    formatTime(list) {
      const listData = []
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const timer = list[i].replace(/-/g, '')
          listData.push(timer)
        }
      }
      return listData
    },
    getThisWeek: function() {
      // 起止日期数组 本周
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 返回date是一周中的某一天
      var week = this.currentDate.getDay()
      // 减去的天数
      var minusDay = week != 0 ? week - 1 : 6
      // 本周 周一
      var monday = new Date(this.currentDate.getTime() - (minusDay * this.millisecond))
      // 本周 周日
      // var sunday = new Date(monday.getTime() + (6 * this.millisecond))
      // 添加本周时间
      startStop.push(this.formatterDate(monday)) // 本周起始时间
      const today1 = util.dateDayFormate(Number(new Date())) // 今天
      // 添加本周最后一天时间
      startStop.push(today1) // 本周终止时间
      // startStop.push(this.formatterDate(sunday)) // 本周终止时间
      // 返回
      return startStop
    },
    /**
      * 获得上一周的起止日期
      */
    getLastWeek: function() {
      // 起止日期数组
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 返回date是一周中的某一天
      var week = this.currentDate.getDay()
      // 减去的天数
      var minusDay = week != 0 ? week - 1 : 6
      // 获得当前周的第一天
      var currentWeekDayOne = new Date(this.currentDate.getTime() - (this.millisecond * minusDay))
      // 上周最后一天即本周开始的前一天
      var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - this.millisecond)
      // 上周的第一天
      var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (this.millisecond * 6))

      startStop.push(this.formatterDate(priorWeekFirstDay))
      startStop.push(this.formatterDate(priorWeekLastDay))
      // 返回
      return startStop
    },
    /**
      * 获得这个月的起止日期
      */
    getThisMonth: function() {
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 获得当前月份0-11
      var currentMonth = this.currentDate.getMonth()
      // 获得当前年份4位年
      var currentYear = this.currentDate.getFullYear()
      // 求出本月第一天
      var firstDay = new Date(currentYear, currentMonth, 1)
      // 当为12月的时候年份需要加1
      // 月份需要更新为0 也就是下一年的第一个月
      // 否则只是月份增加,以便求的下一月的第一天
      if (currentMonth == 11) {
        currentYear++
        currentMonth = 0
      } else {
        currentMonth++
      }
      // var nextMonthDayOne = new Date(currentYear, currentMonth, 1)
      // 求出上月的最后一天
      // var lastDay = new Date(nextMonthDayOne.getTime() - this.millisecond)
      const today1 = util.dateDayFormate(Number(new Date())) // 今天
      // 添加本周最后一天时间
      startStop.push(this.formatterDate(firstDay))
      // startStop.push(this.formatterDate(lastDay))
      startStop.push(today1) // 本周终止时间
      // 返回
      return startStop
    },
    /**
       * 获得上个月的起止日期
       */
    getLastMonth: function() {
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 获得当前月份0-11
      var currentMonth = this.currentDate.getMonth()
      // 获得当前年份4位年
      var currentYear = this.currentDate.getFullYear()
      var currentDay = new Date(currentYear, currentMonth, 1)
      // 上个月的第一天
      // 年份为0代表,是本年的第一月,所以不能减
      if (currentMonth == 0) {
        currentMonth = 11 // 月份为上年的最后月份
        currentYear-- // 年份减1
      } else {
        currentMonth--
      }
      var firstDay = new Date(currentYear, currentMonth, 1)
      // 求出上月的最后一天
      var lastDay = new Date(currentDay.getTime() - this.millisecond)

      startStop.push(this.formatterDate(firstDay))
      startStop.push(this.formatterDate(lastDay))
      // 返回
      return startStop
    },
    /**
      * 格式化日期（不含时间）
      */
    formatterDate: function(date) {
      var datetime = date.getFullYear() +
            '-' +// "年"
            ((date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' +
            (date.getMonth() + 1)) +
            '-' +// "月"
            (date.getDate() < 10 ? '0' + date.getDate() : date
              .getDate())
      return datetime
    },
    changeRadio(val) {
      switch (val) {
        case 0: // 当前
          this.search.time = [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
          break
        case 1: // 昨天
          this.search.time = [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)]
          break
        case 2: // 上周
          this.search.time = this.formatTime(this.getLastWeek())
          break
        case 3: // 本周
          this.search.time = this.formatTime(this.getThisWeek())
          break
        case 4: // 上月
          this.search.time = this.formatTime(this.getLastMonth())
          break
        case 5: // 本月
          this.search.time = this.formatTime(this.getThisMonth())
          break
        case 6: // 最近三个月
          this.search.time = [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)]
          break
        default:
          this.search.time = [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)]
      }
    }
  }
})
</script>
<style lang="scss">
// 时间选择器
.whiteDate {
    .el-date-table {
      td {
        &.start-date,&.end-date {
          span {
            background: #000000;
            color: #ffffff !important;
          }
        }
        &.in-range span {
          color: #000000;
        }
        &.today span {
          color: #000000;
        }
      }
  }
  .el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div {
    background-color: rgba(100, 100, 100, 0.1);
  }
}
</style>
